import axios from "axios";
import baseUrl from "../api/baseUrl";
import app from '../main'


axios.defaults.baseURL = baseUrl;
// console.log('baseUrl', baseUrl);
export default axios.defaults.baseURL;

// 请求超时时间
axios.defaults.timeout = 10000;

// header携带cookie
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        // showLoading();
	    // console.log('config',config);
	    // let userInfo = app.$L.myLocal('__USERINFO__');
	    // config.headers['tokenSSO'] = (userInfo && userInfo.tokenSSO) || '';
	    return config;
    },
    error => {
        return Promise.reject(error);
    }
);
//
// // 响应拦截器
axios.interceptors.response.use(
	response => {
		// console.log('response__',response);
		// hideLoading();
		if (response.status === 200) {
			// app.$Message.info('test');
			// console.log('response__',response);

			// if(response.data.code !== 200){
			// 	console.log('不正常返回');
			// 	let code = response.data.code ;
			//
			// 	let content = response.data.message ||'请求结果错误';
			// 	// console.log('content',content);
			// 	switch (code) {
			// 		case 401:
			// 			console.log(123);
			// 			app.$myAlert(content).then(()=>{
			// 				console.log(12);
			// 				app.$router.replace({path:'/login'})
			// 			})
			//
			// 			break;
			// 		default:
			// 			app.$Message.error({
			// 				content:content,
			// 				duration:2
			// 			});
			// 			break;
			//
			// 	}
			// 	// return Promise.resolve(response);
			// }
			return Promise.resolve(response);
		} else {
			return Promise.reject(response);
		}
	},
	// 服务器状态码不是200的情况
	error => {
		console.log('error__', error);
		// debugger
		if (error.response.status) {
			switch (error.response.status) {
				// 401: 未登录
				// 未登录则跳转登录页面，并携带当前页面的路径
				// 在登录成功后返回当前页面，这一步需要在登录页操作。
				case 401:
					// console.log(window.location.href);

					// let url = window.location.protocol + '//' + window.location.host + '/#/login';
					// console.log(url);
					// window.location.href = url;
					app.$router.replace({path:'/login'})

					break;
				// 403 token过期
				// 登录过期对用户进行提示
				// 清除本地token和清空vuex中token对象
				// 跳转登录页面

				case 403:
					// 清除token
					// 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
					// Toast("服务器内部错误");

					break;
				// 404请求不存在
				case 404:
					// Toast("网络异常");
					break;
				// 其他错误，直接抛出错误提示
				case 500:
					app.$Message.error('系统错误，请稍后再试');
					console.log('系统错误');
					break;
			}
			return Promise.reject(error.response);
		}
	}
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios
			.get(url, {
				params: params
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data);
			});
	});
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// export function post(url, params) {
//   return new Promise((resolve, reject) => {
//     axios
//       .post(url, QS.stringify(params))
//       .then(res => {
//         console.log(res)
//         resolve(res.data);
//       })
//       .catch(err => {
//         reject(err.data);
//       });
//   });
// }

//post 兼容ie的写法，不需要引入qs
export function post(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios(url, {
			method: 'post',
			params: params,
			data:params,
			header:{
				'Content-Type':'application/json'  //如果写成contentType会报错
			}
		})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data);
			});
	})
}



export const Request = {
	err:()=>{
		app.$router.push({path:'/login'})
	},

	get:(url, params) =>{
		return new Promise((resolve, reject) => {
			axios
				.get(url, {
					params: params
				})
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					// app.$router.push({path:'/login'});
					reject(err.data);
				});
		});
	},
	/**
	 * post 请求
	 * @param url 请求url地址
	 * @param params 请求参数
	 * @param type 可选data（将数据保存在头部字符串形式）,params（将参数保存在请求体内）,all（请求体和请求头都放数据）
	 * @returns {Promise<unknown>}
	 */
	post:(url,params,type='data')=>{
		let postData = {
			method: 'post',
			header:{
				'Content-Type':'application/json'  //如果写成contentType会报错
			}
		};
		switch (type) {
			case "data":
				postData.data = params;
				break;
			case 'params':
				postData.params = params;
				break;
			case 'all':
				postData.params = params;
				postData.data = params;
				break;
		}

		return new Promise((resolve, reject) => {
			axios(url, postData)
				.then(res => {
					// console.log('post success:', res);
					resolve(res.data);
					// reject(res.data);
				})
				.catch(err => {
					console.log('post err:', err);
					// app.$router.push({path:'/login'});
					reject(err.data);
				});
		})

	},
	/**
	 * put方法，对应put请求
	 * @param {String} url [请求的url地址]
	 * @param  params [请求时携带的参数]
	 * @returns {Promise<unknown>}
	 */
	put:(url,params)=>{
		return new Promise((resolve, reject) => {
			axios.put(url, params)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err.data)
				})
		});
	},
	/**
	 * delete 方法
	 * @param {String} url [请求的url地址]
	 * @param  params [请求时携带的参数]
	 * @returns {Promise<unknown>}
	 */
	delete:(url, params)=> {
		return new Promise((resolve, reject) => {
			axios.delete(url, params)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err.data)
				})
		});
	}
}





// WEBPACK FOOTER //
// ./src/utils/request.js